module.exports = __webpack_public_path__ + "static/media/20201219_135409_136_IMG_3477.176b6815.jpg";